<template>
  <div class="col-12">
  <q-btn outline :disable="loading" icon="fas fa-share-alt" @click="share" color="secondary" style="float:left; margin:-38px 0 3px 5px;" />
  <q-btn outline :disable="loading" @click="newScorePage" style="float:right; margin:-38px 5px 3px 0;" color="grey" class="new_btnnw" label="New" />
  <q-checkbox v-if="tableData.length === 1" v-model="isSanma" color="amber" checked-icon="fas fa-fish" unchecked-icon="fas fa-fish" style="margin-top:-40px;" />

  <TheScoreTable/>
  <TheScoreSlider/>

  <div class="col-6 add_row_btn">
    <q-btn outline :disable="loading" color="primary" label="" icon="fas fa-check" size="1rem" @click="addRow()" class="full-width add_btn" />
  </div>

  <!-- total table-->
  <div style="padding-bottom: 60px;">
    <q-table :data="totalPoints" :columns="columns" row-key="name" hide-header hide-bottom class="total-points" />
  </div>

  </div>
</template>
<style lang="scss">
  .total-points {
      margin-top:10px;
      td.text-center {
        color:red;
        font-weight:bold;
      }
  }
  i.fas.fa-fish {
     font-size: 3rem;
  }
  .q-item {
      padding-left:0;
      padding-right:0;
  }
  div.add_row_btn {
      padding: 10px;
  }

  .deep-purple-2 { color: #d1c4e9; }
  .teal-2        { color: #b2dfdb; }
  .pink-2        { color: #f8bbd0; }
  .deep-orange-2 { color: #ffccbd; }

</style>
<script>
import firebase from 'firebase'
import TheScoreSlider from './TheScoreSlider.vue'
import TheScoreTable from './TheScoreTable.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    TheScoreSlider,
    TheScoreTable
  },
  created () {
    this.changeLoading(true)
    this.checkLogin()
    this.checkParameter()
  },
  beforeRouteUpdate (to, from, next) {
    // ルート変更に反応する...
    // parameter の変更に反応する
    this.changeLoading(true)
    this.checkLogin()
    this.checkParameter()
    next()
  },
  computed: {
    ...mapGetters('UserInfo', {
      myScoreID: 'getMyScoreID',
      myUID: 'getMyUID',
      myDisplayName: 'getMyDisplayName'
    }),
    ...mapGetters('ScoreTable', {
      tableData: 'getTableData',
      columns: 'getColumns',
      loading: 'getLoading',
      currentPageNum: 'getCurrentPageNum'
    }),
    // total point
    totalPoints () {
      let result = [{}]
      for (let arrayIndex in this.tableData) {
        for (let key in this.tableData[arrayIndex]) {
          if (key === '__index') {
            continue
          }
          if (result[0][key] === undefined) {
            result[0][key] = this.tableData[arrayIndex][key]
            continue
          }
          result[0][key] += this.tableData[arrayIndex][key]
        }
      }
      return result
    },
    isSanma: {
      get () {
        return this.getIsSanma()
      },
      set (value) {
        if (value) {
          this.toSanma()
          this.sliderToSanma()
        } else {
          this.toYonma()
          this.sliderToYonma()
        }
        this.changeIsSanma(value)
      }
    }
  },
  methods: {
    ...mapGetters('ScoreTable', {
      getIsSanma: 'getIsSanma'
    }),
    ...mapMutations('ScoreTable', {
      changeLoading: 'changeLoading',
      setColumnLabel: 'setColumnLabel',
      setColumnUID: 'setColumnUID',
      addScoreRow: 'addScoreRow',
      changeIsSanma: 'changeIsSanma',
      toSanma: 'toSanma',
      toYonma: 'toYonma',
      changeCurrentPageNum: 'changeCurrentPageNum'
    }),
    ...mapMutations('UserInfo', {
      setMyScoreID: 'setMyScoreID',
      setMyUID: 'setMyUID',
      setMyDisplayName: 'setMyDisplayName'
    }),
    ...mapMutations('TheScoreSlider', {
      sliderToSanma: 'toSanma',
      sliderToYonma: 'toYonma'
    }),
    ...mapActions('ScoreTable', {
      setDataFromScoreID: 'setDataFromScoreID',
      resetData: 'reset',
      makeNewScore: 'makeNewScoreDB',
      setMemberToUserDB: 'setScoreMemberToUserDB',
      updateDBScoreMember: 'updateDBScoreMember',
      updateScoreDB: 'updateScoreDB',
      updateScoreMemberOfUserDB: 'updateScoreMemberOfUserDB',
      unsubscribeListenData: 'unsubscribeListenData',
      listenDataFromScoreDB: 'listenDataFromScoreDB'
    }),
    checkLogin () {
      firebase.auth().onAuthStateChanged(user => {
        if (!user) {
          // no Sign in
          this.goLoginPage()
        } else {
          let displayName = user.displayName
          if (user.isAnonymous) {
            displayName = 'A'
          }
          this.setColumnLabel({num: 0, val: displayName})
          this.setColumnUID({num: 0, val: user.uid})
          this.setMyUID(user.uid)
          this.setMyDisplayName(displayName)
        }
      })
    },
    async checkParameter () {
      const scoreID = this.$route.params.id
      if (!scoreID) {
        this.changeLoading(false)
        return
      }
      this.setMyScoreID(scoreID)
      await this.setDataFromScoreID(scoreID)
      this.changeLoading(false)
    },
    goLoginPage () {
      this.$router.push({name: 'Login'})
    },
    addRow: function () {
      this.addScoreRow()
      this.addScoreToFireStore()
    },
    // auto input last data
    async addScoreToFireStore () {
      const now = firebase.firestore.FieldValue.serverTimestamp()
      if (this.myScoreID === '') {
        const scoreID = await this.makeNewScore({tableData: this.tableData, timestamp: now})
        this.setMyScoreID(scoreID)
        this.setMemberToUserDB({scoreID: scoreID, uid: this.myUID, timestamp: now})
        this.updateDBScoreMember({scoreID: scoreID})
        this.listenDataFromScoreDB(scoreID)
      } else {
        this.updateScoreDB({scoreID: this.myScoreID, tableData: this.tableData, timestamp: now})
        this.updateScoreMemberOfUserDB({uid: this.myUID, scoreID: this.myScoreID, timestamp: now})
        this.updateDBScoreMember({scoreID: this.myScoreID})
      }
    },
    newScorePage () {
      this.changeLoading(true)
      this.resetData()
      this.setMyScoreID('')
      this.checkLogin()
      this.changeLoading(false)
    },
    async share () {
      this.changeLoading(true)

      if (this.myScoreID === '') {
        const scoreID = await this.makeNewScore({tableData: this.tableData, timestamp: firebase.firestore.FieldValue.serverTimestamp()})
        this.setMyScoreID(scoreID)
        this.setMemberToUserDB({scoreID: scoreID, uid: this.myUID, timestamp: firebase.firestore.FieldValue.serverTimestamp()})
        this.updateDBScoreMember({scoreID: scoreID})
        this.listenDataFromScoreDB(scoreID)

        // makeNewScore関数を使うとその後のクリップボードへのcopy処理がうまくいかないためここで処理を終了
        this.changeLoading(false)
        return
      }
      this.copyToClipBoard()
      this.changeLoading(false)
    },
    copyToClipBoard () {
      let ta = document.createElement('textArea')
      // Copy to clip board
      const shareUrl = 'https://' + window.location.hostname + '?share_score_id=' + this.myScoreID + '&' + 'openExternalBrowser=1'
      ta.value = shareUrl
      document.body.appendChild(ta)

      // ios
      if (navigator.userAgent.match(/ipad|iphone/i)) {
        let range = document.createRange()
        range.selectNodeContents(ta)
        let selection = window.getSelection()
        selection.removeAllRanges()
        selection.addRange(range)
        ta.setSelectionRange(0, 999999)
      } else {
        ta.select()
      }
      document.execCommand('copy')
      ta.parentElement.removeChild(ta)

      alert('クリップボードに共有URL \n' + shareUrl + '\n をCOPYしました')
    }
  },
  watch: {
    myScoreID (newValue, oldValue) {
      if (oldValue === '') {
        return
      }
      this.unsubscribeListenData()
    },
    tableData () {
      let pageNum = this.tableData.length / 5
      this.changeCurrentPageNum(Math.ceil(pageNum))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ScorePage.vue